import { render, staticRenderFns } from "./hotCity.vue?vue&type=template&id=ee6e5200&scoped=true&"
import script from "./hotCity.vue?vue&type=script&lang=js&"
export * from "./hotCity.vue?vue&type=script&lang=js&"
import style0 from "./hotCity.vue?vue&type=style&index=0&id=ee6e5200&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6e5200",
  null
  
)

export default component.exports